import { Route } from '@angular/router';
import {CombineComponent} from './combine.component';

export const CombineRoutes: Route[] = [
  {
    path: 'combine/:jobid',
    component: CombineComponent
  }
];
